import {
  IWebsiteBuilderContainerBase,
  IWebsiteBuilderContainerDataBase,
} from "./websiteBuilderContainer";
import { IWebsiteBuilderNodeDesignStyles } from "../websiteBuilderNode";
import {
  websiteBuilderGenerateDefaultHideableNodeVisibility,
} from "../websiteBuilderHideableNode";
import { IWebsiteBuilderTab, websiteBuilderGenerateDefaultTab } from "../tab/websiteBuilderTab";
import { IWebsiteBuilderNodePosition } from "../websiteBuilderNodeGeometry";
import { CSSProperties } from "react";

export const WEBSITE_BUILDER_TABSET_MIN_TABS = 0;
export const WEBSITE_BUILDER_TABSET_MAX_TABS = 25;

export const WEBSITE_BUILDER_TABSET_HEADER_HEIGHT = 50;

export interface IWebsiteBuilderTabsetSettings {
  defaultTabId: string;
}

interface IWebsiteBuilderTabsetData extends IWebsiteBuilderContainerDataBase {
  type: "tabset";
  settings: IWebsiteBuilderTabsetSettings;
}

export interface IWebsiteBuilderTabset extends IWebsiteBuilderContainerBase<IWebsiteBuilderTab[]> {
  container: IWebsiteBuilderTabsetData;
}

export function isWebsiteBuilderTabset(node: any): node is IWebsiteBuilderTabset {
  return node?.type === "container" && node.container?.type === "tabset";
}

export function websiteBuilderGetTabsetPosition(
  position: IWebsiteBuilderNodePosition,
): IWebsiteBuilderNodePosition {
  return {
    x: position.x,
    y: position.y + WEBSITE_BUILDER_TABSET_HEADER_HEIGHT,
  };
}

export function websiteBuilderGenerateDefaultTabset(): IWebsiteBuilderTabset {
  const children = [
    websiteBuilderGenerateDefaultTab("Tab 1"), // TODO: Translation
    websiteBuilderGenerateDefaultTab("Tab 2"), // TODO: Translation
    websiteBuilderGenerateDefaultTab("Tab 3"), // TODO: Translation
  ];

  return {
    id: crypto.randomUUID(),
    type: "container",
    container: {
      type: "tabset",
      layout: {
        desktop: {
          position: { x: 0, y: 0 },
          dimensions: { width: 450, height: 270 },
        },
        tablet: {
          position: { x: 0, y: 0 },
          dimensions: { width: 400, height: 240 },
        },
        mobile: {
          position: { x: 0, y: 0 },
          dimensions: { width: 300, height: 180 },
        },
      },
      visibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
      zIndex: 0,
      settings: {
        defaultTabId: children[0].id,
      },
    },
    children,
  };
}

export function websiteBuilderNormalizeTabsetSettings(
  partialSettings: Partial<IWebsiteBuilderTabsetSettings>,
  tabIds: string[],
): IWebsiteBuilderTabsetSettings {
  const defaultTabId = partialSettings?.defaultTabId;

  return {
    defaultTabId: tabIds.includes(defaultTabId)
      ? defaultTabId
      : tabIds[0] ?? null,
  };
}

interface IWebsiteBuilderTabsetDesignStyles extends IWebsiteBuilderNodeDesignStyles {
  tabHeaderClassName: string;
  tabHeaderStyleProperties: CSSProperties;
  tabHeaderStyleDeclaration: string;
  tabHeaderItemClassName: string;
  tabHeaderItemActiveClassName: string;
}

export function websiteBuilderGenerateTabsetDesignStyles(): IWebsiteBuilderTabsetDesignStyles {
  return {
    className: "website-builder-tabset",
    styleProperties: {},
    styleDeclaration: "",
    tabHeaderClassName: "website-builder-tabset-tab-header",
    tabHeaderStyleProperties: {
      flexBasis: `${WEBSITE_BUILDER_TABSET_HEADER_HEIGHT}px`,
    },
    tabHeaderStyleDeclaration: `flex-basis: ${WEBSITE_BUILDER_TABSET_HEADER_HEIGHT}px;`,
    tabHeaderItemClassName: "website-builder-tabset-tab-header-item",
    tabHeaderItemActiveClassName: "website-builder-tabset-tab-header-item-active",
  };
}
